// extracted by mini-css-extract-plugin
export default {"text":"styles_text__4Rq8E","required":"styles_required__D0zo4"};